<template>
  <div class="hotel-header-lite" :style="isMobile ? 'height:100%;position:relative' : ''">
    <div class="slider js-header-image swiper-container" @click="openGalleryOnClick">
      <div class="slider__content swiper-wrapper" :style="`transform:translateX(-${currentSlide * 100}%)`">
        <slot name="slider_content" />
      </div>
      <button
        v-if="nSlides !== 1 && (isCyclic || (currentSlide !== 0 && !isCyclic))"
        class="slider__controls__prev slider__controls__button"
        @click="prevSlide"
      >
        <span class="sr-only">{{ i18n.prev_slider }}</span>
      </button>
      <button
        v-if="
          (nSlides !== 1 && (isCyclic || isStartLink)) || (!isLastSlide && isStartEnd) || (nSlides == 1 && isStartLink)
        "
        :class="
          isStartLink && isLastSlide
            ? 'slider__controls__next--gallery js-open-hotel-gallery'
            : 'slider__controls__next--active'
        "
        class="slider__controls__next slider__controls__button"
        @click="nextSlide"
      >
        <span class="slider__controls__next__text" :class="isStartLink && isLastSlide ? '' : 'hidden'">{{
          next_text
        }}</span>
        <span class="sr-only">{{ i18n.next_slider }}</span>
      </button>
      <div class="slider__controls__bullets">
        <div
          v-for="(slide, index) in nSlides"
          :key="index"
          :class="`slider__controls__bullets__bullet ${currentSlide === index ? 'slider__controls__bullets__bullet--active' : ''}`"
          @click="moveToSlide(slide - 1, $event)"
        ></div>
        <div
          v-if="isStartLink"
          class="slider__controls__bullets__bullet--gallery js-open-hotel-gallery"
          data-test="hotel-header__open-gallery"
          @click="openGallery"
        >
          <span class="s s-grid icon"></span>
        </div>
      </div>
      <div role="status" class="a11y-visually-hidden">
        {{ announcerText }}
      </div>
    </div>
    <div v-if="!isMobile && use_new_fb == 'true'" class="hotel-header-lite__fastbooking wrapper">
      <Fastbooking :hotel="hotel"></Fastbooking>
    </div>

    <div
      v-if="isMobile"
      class="hotel-header-lite__mobile-title"
      style="position: absolute; top: 50%; left: 0; transform: translateY(-50%); margin: left 20px"
    >
      <span v-html="hotel.stars"></span>
      <h1 class="t-h1" style="width: 350px; max-height: 100px" data-test="hotel-header__hotel-title">
        {{ hotel.title }}
      </h1>
      <span class="hotel-header-lite__mobile-title__zone">
        {{ hotel.zone_title }}
      </span>
    </div>

    <div
      v-if="isMobile"
      class="hotel-header-lite__mobile-buttons"
      style="position: absolute; left: 0; bottom: 60px; margin-left: 20px"
    >
      <a class="button-gallery utag-info-photos js-open-hotel-gallery" @click="openGallery">
        <span class="s s-camera s-m"></span>
        <p class="link-text">{{ i18n.photos_and_videos }}</p>
      </a>
      <slot name="fastbooking_button" />
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
import { Pagination } from 'swiper/modules'

import { sendUtagEvent } from '../../../../core/analytics/utag_events.js'
import { currentDevice } from '../../../../core/utils/currentDevice'
import { openGallery as initHotelGallery } from '../../../../shared/hotel_gallery_modal/hotel_gallery_modal'
import Fastbooking from '../Fastbooking/Fastbooking.vue'

export default {
  name: 'HotelHeaderLite',
  components: {
    Fastbooking,
  },
  props: {
    slides: {
      type: String,
      required: true,
    },
    next_text: {
      type: String,
      required: true,
    },
    carrusel_type: {
      type: String,
      required: true,
    },
    use_new_fb: {
      type: String,
      required: true,
    },
    hotel: {
      type: Object,
      required: true,
    },
    i18n: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    currentSlide: 0,
    isLastSlide: false,
    isCyclic: false,
    isStartEnd: false,
    isStartLink: false,
    announcerText: '',
  }),
  computed: {
    isMobile() {
      return currentDevice.isMobile
    },
    nSlides() {
      return parseInt(this.slides, 10)
    },
  },
  watch: {
    currentSlide() {
      this.isLastSlide = this.currentSlide === this.nSlides - 1
      this.updateAnnouncerText()
    },
  },
  created() {
    this.isLastSlide = this.nSlides === 1
    this.isCyclic = this.carrusel_type === 'cyclic'
    this.isStartEnd = this.carrusel_type === 'start_end'
    this.isStartLink = this.carrusel_type === 'start_link'
  },
  mounted() {
    if (this.isMobile) {
      Swiper.use([Pagination])
      new Swiper('.hotel-header-lite .slider', {
        direction: 'horizontal',
        loop: false,
        navigation: false,
        touch: { enabled: true },
        pagination: {
          el: '.slider__controls__bullets',
          bulletClass: 'slider__controls__bullets__bullet',
          bulletActiveClass: 'slider__controls__bullets__bullet--active',
          clickable: true,
        },
      })
      IB.currencyForm.init()
    }
    this.initVideoSources()
    this.updateAnnouncerText()
  },
  methods: {
    initVideoSources() {
      this.$nextTick(() => {
        const videos = this.$el.querySelectorAll('.js-head-video')

        videos.forEach(video => {
          const { mp4Src, webmSrc } = video.dataset

          if (mp4Src) {
            const s = document.createElement('source')
            s.src = mp4Src
            s.type = 'video/mp4'
            video.appendChild(s)
          }
          if (webmSrc) {
            const s = document.createElement('source')
            s.src = webmSrc
            s.type = 'video/webm'
            video.appendChild(s)
          }
        })
      })
    },
    nextSlide(event) {
      event.preventDefault()
      event.stopPropagation()
      if (this.currentSlide < this.nSlides - 1) {
        this.currentSlide++
        this.sendEvent(false)
      } else if (this.isCyclic) {
        this.currentSlide = 0
        this.sendEvent(false)
      } else if (this.isStartLink) {
        this.openGallery(event)
      }
    },
    prevSlide(event) {
      event.preventDefault()
      event.stopPropagation()
      if (this.currentSlide > 0) {
        this.currentSlide--
      } else if (this.isCyclic) {
        this.currentSlide = this.nSlides - 1
      }
      this.sendEvent(false)
    },
    openGalleryOnClick(event) {
      event.preventDefault()
      event.stopPropagation()

      if (this.nSlides === 1) {
        initHotelGallery(event)
      }
    },
    openGallery(event) {
      event.preventDefault()
      event.stopPropagation()
      initHotelGallery(event)
      this.sendEvent(true)
    },
    moveToSlide(index, event) {
      event.preventDefault()
      event.stopPropagation()
      this.currentSlide = index
    },
    sendEvent(isGallery) {
      const event_lbl = isGallery ? 'go to gallery' : 'header'
      sendUtagEvent({
        data: {
          event_name: 'hotel_multimedia',
          event_cat: 'hotel information',
          event_act: 'see photos and videos',
          event_lbl,
          event_purpose: 'inspiration',
          event_structure: 'header',
        },
      })
    },
    updateAnnouncerText() {
      this.$nextTick(() => {
        const slideNumber = this.currentSlide + 1
        const totalSlides = this.nSlides

        const template = this.i18n.announcer_slide_status_template

        if (template) {
          this.announcerText = template.replace('%{slideNumber}', slideNumber).replace('%{totalSlides}', totalSlides)
        }
      })
    },
  },
}
</script>
